import React, { FC } from 'react';

import LoaderWrap from './LoaderWrap';
import Loader from './index';

interface IProps {
  size?: 'md';
  className?: string;
}

const LoaderFallback: FC<IProps> = ({ size, className }) => (
  <LoaderWrap className={className}>
    <Loader size={size} />
  </LoaderWrap>
);

export default LoaderFallback;
